import React from 'react';
import styled from 'styled-components';
import { propStyling } from '../../../shared/propStyling';
import { tombac } from '../../../shared/tombac';
const Container = styled.div.withConfig({
  displayName: "ModalActions__Container"
})(["display:flex;gap:", ";margin:", ";", ""], tombac.space(2), tombac.space(3), propStyling);
const PrimaryActions = styled.div.withConfig({
  displayName: "ModalActions__PrimaryActions"
})(["display:flex;gap:", ";margin-left:auto;order:2;"], tombac.space(1));
const SecondaryActions = styled.div.withConfig({
  displayName: "ModalActions__SecondaryActions"
})(["display:flex;gap:", ";order:1;"], tombac.space(1));
export const ModalActions = _ref => {
  let {
    children,
    secondary,
    ...stylingProps
  } = _ref;
  return /*#__PURE__*/React.createElement(Container, stylingProps, children && /*#__PURE__*/React.createElement(PrimaryActions, null, children), secondary && /*#__PURE__*/React.createElement(SecondaryActions, null, secondary));
};
//# sourceMappingURL=ModalActions.js.map